import $ from "jquery";

const donationForm = () => {
    const $customRadio = $(".js-custom-option");
    const $customAmountInput = $(".js-custom-input");
    const $radioButtons = $(".js-donation-radio");
    const $form = $(".js-donation-form");
    const $hiddenAmountInput = $(".js-hidden-amount"); // Hidden number input to store the donation in pence

    $customAmountInput.hide(); // Hide the custom input initially

    // Handle the change event for the radio buttons
    $radioButtons.on("change", function () {
        if ($(this).is($customRadio)) {
            $customRadio.next("span").addClass("expanded"); // Add class to expand button
            $customAmountInput.prop("disabled", false).show().focus();
        } else {
            $customRadio.next("span").removeClass("expanded");
            $customAmountInput.prop("disabled", true).hide().val("");
            // Update the hidden amount input based on the selected radio button
            const selectedValue = $(this).val();
            updateHiddenAmount(selectedValue);
        }
    });

    // Handle custom input changes
    $customAmountInput.on({
        keyup: function () {
            formatCurrency($(this));
            const customValue = $(this)
                .val()
                .replace(/[^0-9\.]/g, ""); // Remove non-numeric characters
            updateHiddenAmount(customValue); // Update the hidden input with the custom value in pence
        },
        blur: function () {
            formatCurrency($(this), "blur");
        },
    });

    // Validate the form on submit
    $form.on("submit", function (event) {
        event.preventDefault(); // Prevent form submission to run validation first

        var isValid = false;

        // Check if any radio button is selected
        if ($radioButtons.is(":checked")) {
            // If "Other amount" is selected, check if a value is provided in the custom input
            if (
                $customRadio.is(":checked") &&
                $customAmountInput.prop("disabled") === false &&
                $customAmountInput.val().trim() === ""
            ) {
                alert("Please enter a custom amount.");
                isValid = false;
            } else {
                isValid = true;
            }
        } else {
            alert("Please select a donation amount.");
            isValid = false;
        }

        // If validation passes, submit the form manually
        if (isValid) {
            $form[0].submit(); // Trigger actual form submission
        } else {
        }
    });

    // Enable or disable custom input when the "Other amount" radio is selected
    $(".js-set-amount").on("change", function () {
        if ($('input[name="donation"][value="custom"]:checked').length) {
            $customAmountInput.prop("disabled", false);
        } else {
            $customAmountInput.prop("disabled", true).val(""); // Clear the custom input if not selected
        }
    });

    function formatNumber(n) {
        return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function formatCurrency(input, blur) {
        var input_val = input.val();
        if (input_val === "") {
            return;
        }

        var original_len = input_val.length;
        var caret_pos = input.prop("selectionStart");

        if (input_val.indexOf(".") >= 0) {
            var decimal_pos = input_val.indexOf(".");
            var left_side = input_val.substring(0, decimal_pos);
            var right_side = input_val.substring(decimal_pos);
            left_side = formatNumber(left_side);
            right_side = formatNumber(right_side);

            if (blur === "blur") {
                right_side += "00";
            }

            right_side = right_side.substring(0, 2);
            input_val = "£" + left_side + "." + right_side;
        } else {
            input_val = formatNumber(input_val);
            input_val = "£" + input_val;
            if (blur === "blur") {
                input_val += ".00";
            }
        }

        input.val(input_val);
        var updated_len = input_val.length;
        caret_pos = updated_len - original_len + caret_pos;
        input[0].setSelectionRange(caret_pos, caret_pos);
    }

    function updateHiddenAmount(amount) {
        if (amount && !isNaN(amount)) {
            // Convert the amount to pence and set it in the hidden input
            const penceAmount = Math.round(parseFloat(amount) * 100); // Multiply by 100 to convert to pence
            $hiddenAmountInput.val(penceAmount); // Update the hidden input
        }
    }
};

export default donationForm;
